import {
  DataProvider,
  GetOneParams,
  GetOneResult,
  UpdateParams,
  UpdateResult,
} from "react-admin";
import baseDataProvider from "../dataProvider/baseDataProvider";
import { gql, postGraphql, postGraphqlMutation } from "../dataProvider/utils";

const clinicMdPracticeMappingsDataProvider: DataProvider = {
  ...baseDataProvider,
  async getOne(
    resource: string,
    params: GetOneParams
  ): Promise<GetOneResult<any>> {
    const response = await postGraphql(
      gql`
        query UAClinicMDPracticeMappingGetOne($id: ID!) {
          clinic(id: $id) {
            id
            name
            mdPracticeId
          }
        }
      `,
      { id: params.id }
    );
    const { clinic } = response.json.data;
    return { data: clinic };
  },

  async update(
    resource: string,
    params: UpdateParams
  ): Promise<UpdateResult<any>> {
    const { id, data } = params;
    const response = await postGraphqlMutation(
      gql`
        mutation UAClinicMDPracticeMappingUpdate(
          $id: ID!
          $input: UpdateClinicMDPracticeMappingInput!
        ) {
          mutation: updateClinicMDPracticeMapping(id: $id, input: $input) {
            status
            errors {
              key
              details {
                code
                message
              }
            }
            payload {
              id
              name
            }
          }
        }
      `,
      {
        id,
        input: {
          mdPracticeId: data.remove ? null : data.mdPracticeId,
        },
      },
      "mutation"
    );
    return {
      data: { ...data, ...response.json.data.mutation.payload },
    };
  },
};

export default clinicMdPracticeMappingsDataProvider;
